import { render, staticRenderFns } from "./_tabInfo.vue?vue&type=template&id=08357ee9&scoped=true&"
import script from "./_tabInfo.vue?vue&type=script&lang=js&"
export * from "./_tabInfo.vue?vue&type=script&lang=js&"
import style0 from "./_tabInfo.vue?vue&type=style&index=0&id=08357ee9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08357ee9",
  null
  
)

export default component.exports